var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{ref:"input",staticClass:"form-control",attrs:{"type":"text","data-cy":"caseNumber","readonly":""},domProps:{"value":_vm.$route.params.caseNumber}})])])}
var staticRenderFns = []

export { render, staticRenderFns }